export class Keys {
  public static token = 'token'
  public static refresh_token = 'refresh_token'
}
